import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header-title',
  templateUrl: './header-title.component.html',
  styleUrls: ['./header-title.component.scss'],
})
export class PageHeaderTitle {
  @Input({ required: true }) public dataTestId: string;
  @Input({ required: true }) public titleHint: string;
  @Input({ required: true }) public link: string;
  @Input({ required: true }) public itemId: string;
  @Input({ required: true }) public title: string;
}
